import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { keycloakAuthApiRef, keycloakAuthApiExtension } from './apis';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'keycloak',
            title: 'Keycloak SSO',
            message: 'Sign in with Keycloak SSO',
            apiRef: keycloakAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [catalogPlugin, navModule, 
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage, keycloakAuthApiExtension],
    })],
});